export default __webpack_public_path__ + "static/media/poolPartyLogo.38fc8115.png";